// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const gardenBench = defineModel({
  id: "garden-bench",
  batchId: "future",
  name: "Garden bench",
  tags: ["scenery","garden","bench","low-poly","age-of-mcp","future"],
  summary: "A garden bench — public seating in parks and squares.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: "#3a3f44", position: [0.06, 0.08, 0.21] },
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: "#3a3f44", position: [-0.1, 0.08, 0.21] },
      { geometry: new THREE.BoxGeometry(0.2, 0.03, 0.04), color: "#3a3f44", position: [-0.02, 0.16, 0.21] },
      { geometry: new THREE.BoxGeometry(0.03, 0.22, 0.03), color: "#3a3f44", position: [-0.1, 0.27, 0.21], rotation: [0, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.22, 0.025, 0.025), color: "#7a522e", position: [0, 0.3, 0.21] },
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: "#3a3f44", position: [0.06, 0.08, -0.21] },
      { geometry: new THREE.BoxGeometry(0.04, 0.16, 0.04), color: "#3a3f44", position: [-0.1, 0.08, -0.21] },
      { geometry: new THREE.BoxGeometry(0.2, 0.03, 0.04), color: "#3a3f44", position: [-0.02, 0.16, -0.21] },
      { geometry: new THREE.BoxGeometry(0.03, 0.22, 0.03), color: "#3a3f44", position: [-0.1, 0.27, -0.21], rotation: [0, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.22, 0.025, 0.025), color: "#7a522e", position: [0, 0.3, -0.21] },
      { geometry: new THREE.BoxGeometry(0.05, 0.025, 0.5), color: "#9a6a3c", position: [-0.06, 0.175, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.025, 0.5), color: "#9a6a3c", position: [0.02, 0.175, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.025, 0.5), color: "#9a6a3c", position: [0.1, 0.175, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.05, 0.5), color: "#9a6a3c", position: [-0.12, 0.24, 0], rotation: [0, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.04, 0.05, 0.5), color: "#9a6a3c", position: [-0.12, 0.32, 0], rotation: [0, 0, 0.12] },
    ],
  animations: [],
});
